interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  faqData?: { question: string; answer: string }[];
  articleData?: {
    headline: string;
    description: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
    imageUrl?: string;
  };
}

export default function SchemaOrg({ type, data, faqData, articleData }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '韩漫之家',
        url: 'https://www.hanmanzhijia.com',
        description: '韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快。',
        ...(data || {}),
      };
      break;
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '韩漫之家',
        url: 'https://www.hanmanzhijia.com',
        description: '韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.hanmanzhijia.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
        ...(data || {}),
      };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '韩漫之家',
        description: '韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快。',
        ...(data || {}),
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: articleData?.headline || '',
        description: articleData?.description || '',
        datePublished: articleData?.datePublished || '',
        dateModified: articleData?.dateModified || '',
        author: {
          '@type': 'Person',
          name: articleData?.authorName || '',
        },
        ...(articleData?.imageUrl ? { image: articleData.imageUrl } : {}),
        publisher: {
          '@type': 'Organization',
          name: '韩漫之家',
        },
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (faqData || []).map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      };
      break;
    default:
      schema = {};
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}